import GalleryComp from "../components/GalleryComp";
import PageHeader from "./../components/PageHeader";

const Gallery = () => {
  return (
    <>
      <PageHeader />
      <GalleryComp />
    </>
  );
};

export default Gallery;
